import { APIPersonalAutoApplicationForm } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';

export const processPolicyData = (
  applicationData: APIPersonalAutoApplicationForm,
): BinderSectionData => {
  const companyAndBroker = applicationData.company_and_broker_information;
  const applicant = applicationData.applicant;
  const policyPeriod = applicationData.policy_period;
  const declaration = applicationData.declaration_of_applicant;

  // Format address
  const formatAddress = (
    applicantData: APIPersonalAutoApplicationForm['applicant'],
  ) => {
    const parts = [
      applicantData.address,
      applicantData.city,
      applicantData.province_code,
      applicantData.postal_code,
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : 'N/A';
  };

  // Format date and time
  const formatDateTime = (date: string, time?: string) => {
    if (!date) return 'N/A';
    return time ? `${date} (${time})` : date;
  };

  const policyInfo = [
    {
      field: 'Insurance Company',
      value: companyAndBroker.insurance_company || 'N/A',
    },
    { field: 'Producer Code', value: companyAndBroker.producer_code || 'N/A' },
    { field: 'CSR Code', value: companyAndBroker.broker_csr_code || 'N/A' }, // Not found in data
    {
      field: 'Binder Number',
      value: applicationData.policy_information?.policy_no_assigned || 'N/A',
    }, // Not found in data
    {
      field: 'Premium',
      value: applicationData.method_of_payment.estimated_policy_premium,
    }, // Not found in data
    { field: 'Customer Code', value: 'N/A' }, // Not found in data
    { field: 'Broker Code', value: companyAndBroker.broker_code || 'N/A' },
    {
      field: 'Named Insured & Address',
      value: `${applicant.first_name} ${applicant.last_name} - ${formatAddress(
        applicant,
      )}`,
    },
    {
      field: 'Lessor',
      value: applicationData.vehicles[0]?.lessor?.name || 'N/A',
    },
    {
      field: 'Effective Date/Time',
      value: formatDateTime(
        policyPeriod.effective_date,
        policyPeriod.effective_date_time,
      ),
    },
    {
      field: 'Expiry Date/Time',
      value: formatDateTime(policyPeriod.expiry_date),
    },
    { field: 'Signed Name', value: declaration.signature || 'N/A' },
    { field: 'Signed Date', value: declaration.date || 'N/A' },
    { field: 'Market Approval Reference', value: 'N/A' }, // Not found in data
    { field: 'Market Approval Underwriter', value: 'N/A' }, // Not found in data
    { field: 'Market Approval Date', value: 'N/A' }, // Not found in data
  ];

  // Count available vs missing fields
  const availableFields = policyInfo.filter(
    (item) => item.value !== 'N/A',
  ).length;

  const isValid = availableFields > 0;

  return {
    title: 'Upload Summary',
    description: null,
    isValid,
    message: null,
    data: {
      policyInfo,
    },
  };
};
